import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { updateUserProfile } from '../../services/userService';
import { clearProfileSnooze } from '../../utils/profileSnooze';

interface ProfileCompletionModalProps {
    isOpen: boolean;
    onClose: () => void;
    onComplete: () => void;
}

// Country codes list
const COUNTRY_CODES = [
    { code: '+1', name: 'United States' },
    { code: '+1', name: 'Canada' },
    { code: '+1', name: 'Bahamas' },
    { code: '+1', name: 'Barbados' },
    { code: '+1', name: 'Anguilla' },
    { code: '+1', name: 'Antigua and Barbuda' },
    { code: '+1', name: 'Bermuda' },
    { code: '+1', name: 'British Virgin Islands' },
    { code: '+1', name: 'Cayman Islands' },
    { code: '+1', name: 'Dominica' },
    { code: '+1', name: 'Dominican Republic' },
    { code: '+1', name: 'Grenada' },
    { code: '+1', name: 'Jamaica' },
    { code: '+1', name: 'Montserrat' },
    { code: '+1', name: 'Puerto Rico' },
    { code: '+1', name: 'Saint Kitts and Nevis' },
    { code: '+1', name: 'Saint Lucia' },
    { code: '+1', name: 'Saint Vincent and the Grenadines' },
    { code: '+1', name: 'Trinidad and Tobago' },
    { code: '+1', name: 'Turks and Caicos Islands' },
    { code: '+7', name: 'Russia' },
    { code: '+7', name: 'Kazakhstan' },
    { code: '+20', name: 'Egypt' },
    { code: '+27', name: 'South Africa' },
    { code: '+30', name: 'Greece' },
    { code: '+31', name: 'Netherlands' },
    { code: '+32', name: 'Belgium' },
    { code: '+33', name: 'France' },
    { code: '+34', name: 'Spain' },
    { code: '+36', name: 'Hungary' },
    { code: '+39', name: 'Italy' },
    { code: '+40', name: 'Romania' },
    { code: '+41', name: 'Switzerland' },
    { code: '+43', name: 'Austria' },
    { code: '+44', name: 'United Kingdom' },
    { code: '+45', name: 'Denmark' },
    { code: '+46', name: 'Sweden' },
    { code: '+47', name: 'Norway' },
    { code: '+48', name: 'Poland' },
    { code: '+49', name: 'Germany' },
    { code: '+51', name: 'Peru' },
    { code: '+52', name: 'Mexico' },
    { code: '+53', name: 'Cuba' },
    { code: '+54', name: 'Argentina' },
    { code: '+55', name: 'Brazil' },
    { code: '+56', name: 'Chile' },
    { code: '+57', name: 'Colombia' },
    { code: '+58', name: 'Venezuela' },
    { code: '+60', name: 'Malaysia' },
    { code: '+61', name: 'Australia' },
    { code: '+62', name: 'Indonesia' },
    { code: '+63', name: 'Philippines' },
    { code: '+64', name: 'New Zealand' },
    { code: '+65', name: 'Singapore' },
    { code: '+66', name: 'Thailand' },
    { code: '+81', name: 'Japan' },
    { code: '+82', name: 'South Korea' },
    { code: '+84', name: 'Vietnam' },
    { code: '+86', name: 'China' },
    { code: '+90', name: 'Turkey' },
    { code: '+91', name: 'India' },
    { code: '+92', name: 'Pakistan' },
    { code: '+93', name: 'Afghanistan' },
    { code: '+94', name: 'Sri Lanka' },
    { code: '+95', name: 'Myanmar' },
    { code: '+98', name: 'Iran' },
    { code: '+211', name: 'South Sudan' },
    { code: '+212', name: 'Morocco' },
    { code: '+213', name: 'Algeria' },
    { code: '+216', name: 'Tunisia' },
    { code: '+218', name: 'Libya' },
    { code: '+220', name: 'Gambia' },
    { code: '+221', name: 'Senegal' },
    { code: '+222', name: 'Mauritania' },
    { code: '+223', name: 'Mali' },
    { code: '+224', name: 'Guinea' },
    { code: '+225', name: 'Ivory Coast' },
    { code: '+226', name: 'Burkina Faso' },
    { code: '+227', name: 'Niger' },
    { code: '+228', name: 'Togo' },
    { code: '+229', name: 'Benin' },
    { code: '+230', name: 'Mauritius' },
    { code: '+231', name: 'Liberia' },
    { code: '+232', name: 'Sierra Leone' },
    { code: '+233', name: 'Ghana' },
    { code: '+234', name: 'Nigeria' },
    { code: '+235', name: 'Chad' },
    { code: '+236', name: 'Central African Republic' },
    { code: '+237', name: 'Cameroon' },
    { code: '+238', name: 'Cape Verde' },
    { code: '+239', name: 'Sao Tome and Principe' },
    { code: '+240', name: 'Equatorial Guinea' },
    { code: '+241', name: 'Gabon' },
    { code: '+242', name: 'Congo' },
    { code: '+243', name: 'DR Congo' },
    { code: '+244', name: 'Angola' },
    { code: '+245', name: 'Guinea-Bissau' },
    { code: '+246', name: 'British Indian Ocean Territory' },
    { code: '+248', name: 'Seychelles' },
    { code: '+249', name: 'Sudan' },
    { code: '+250', name: 'Rwanda' },
    { code: '+251', name: 'Ethiopia' },
    { code: '+252', name: 'Somalia' },
    { code: '+253', name: 'Djibouti' },
    { code: '+254', name: 'Kenya' },
    { code: '+255', name: 'Tanzania' },
    { code: '+256', name: 'Uganda' },
    { code: '+257', name: 'Burundi' },
    { code: '+258', name: 'Mozambique' },
    { code: '+260', name: 'Zambia' },
    { code: '+261', name: 'Madagascar' },
    { code: '+262', name: 'Réunion / Mayotte' },
    { code: '+263', name: 'Zimbabwe' },
    { code: '+264', name: 'Namibia' },
    { code: '+265', name: 'Malawi' },
    { code: '+266', name: 'Lesotho' },
    { code: '+267', name: 'Botswana' },
    { code: '+268', name: 'Eswatini' },
    { code: '+269', name: 'Comoros' },
    { code: '+290', name: 'Saint Helena' },
    { code: '+291', name: 'Eritrea' },
    { code: '+297', name: 'Aruba' },
    { code: '+298', name: 'Faroe Islands' },
    { code: '+299', name: 'Greenland' },
    { code: '+350', name: 'Gibraltar' },
    { code: '+351', name: 'Portugal' },
    { code: '+352', name: 'Luxembourg' },
    { code: '+353', name: 'Ireland' },
    { code: '+354', name: 'Iceland' },
    { code: '+355', name: 'Albania' },
    { code: '+356', name: 'Malta' },
    { code: '+357', name: 'Cyprus' },
    { code: '+358', name: 'Finland' },
    { code: '+359', name: 'Bulgaria' },
    { code: '+370', name: 'Lithuania' },
    { code: '+371', name: 'Latvia' },
    { code: '+372', name: 'Estonia' },
    { code: '+373', name: 'Moldova' },
    { code: '+374', name: 'Armenia' },
    { code: '+375', name: 'Belarus' },
    { code: '+376', name: 'Andorra' },
    { code: '+377', name: 'Monaco' },
    { code: '+378', name: 'San Marino' },
    { code: '+379', name: 'Vatican' },
    { code: '+380', name: 'Ukraine' },
    { code: '+381', name: 'Serbia' },
    { code: '+382', name: 'Montenegro' },
    { code: '+383', name: 'Kosovo' },
    { code: '+385', name: 'Croatia' },
    { code: '+386', name: 'Slovenia' },
    { code: '+387', name: 'Bosnia and Herzegovina' },
    { code: '+389', name: 'North Macedonia' },
    { code: '+420', name: 'Czech Republic' },
    { code: '+421', name: 'Slovakia' },
    { code: '+423', name: 'Liechtenstein' },
    { code: '+500', name: 'Falkland Islands' },
    { code: '+501', name: 'Belize' },
    { code: '+502', name: 'Guatemala' },
    { code: '+503', name: 'El Salvador' },
    { code: '+504', name: 'Honduras' },
    { code: '+505', name: 'Nicaragua' },
    { code: '+506', name: 'Costa Rica' },
    { code: '+507', name: 'Panama' },
    { code: '+508', name: 'Saint Pierre and Miquelon' },
    { code: '+509', name: 'Haiti' },
    { code: '+590', name: 'Guadeloupe' },
    { code: '+591', name: 'Bolivia' },
    { code: '+592', name: 'Guyana' },
    { code: '+593', name: 'Ecuador' },
    { code: '+594', name: 'French Guiana' },
    { code: '+595', name: 'Paraguay' },
    { code: '+596', name: 'Martinique' },
    { code: '+597', name: 'Suriname' },
    { code: '+598', name: 'Uruguay' },
    { code: '+599', name: 'Caribbean Netherlands' },
    { code: '+670', name: 'Timor-Leste' },
    { code: '+672', name: 'Antarctica' },
    { code: '+673', name: 'Brunei' },
    { code: '+674', name: 'Nauru' },
    { code: '+675', name: 'Papua New Guinea' },
    { code: '+676', name: 'Tonga' },
    { code: '+677', name: 'Solomon Islands' },
    { code: '+678', name: 'Vanuatu' },
    { code: '+679', name: 'Fiji' },
    { code: '+680', name: 'Palau' },
    { code: '+681', name: 'Wallis and Futuna' },
    { code: '+682', name: 'Cook Islands' },
    { code: '+683', name: 'Niue' },
    { code: '+685', name: 'Samoa' },
    { code: '+686', name: 'Kiribati' },
    { code: '+687', name: 'New Caledonia' },
    { code: '+688', name: 'Tuvalu' },
    { code: '+689', name: 'French Polynesia' },
    { code: '+690', name: 'Tokelau' },
    { code: '+691', name: 'Micronesia' },
    { code: '+692', name: 'Marshall Islands' },
    { code: '+850', name: 'North Korea' },
    { code: '+852', name: 'Hong Kong' },
    { code: '+853', name: 'Macau' },
    { code: '+855', name: 'Cambodia' },
    { code: '+856', name: 'Laos' },
    { code: '+870', name: 'Inmarsat' },
    { code: '+880', name: 'Bangladesh' },
    { code: '+886', name: 'Taiwan' },
    { code: '+960', name: 'Maldives' },
    { code: '+961', name: 'Lebanon' },
    { code: '+962', name: 'Jordan' },
    { code: '+963', name: 'Syria' },
    { code: '+964', name: 'Iraq' },
    { code: '+965', name: 'Kuwait' },
    { code: '+966', name: 'Saudi Arabia' },
    { code: '+967', name: 'Yemen' },
    { code: '+968', name: 'Oman' },
    { code: '+970', name: 'Palestine' },
    { code: '+971', name: 'United Arab Emirates' },
    { code: '+972', name: 'Israel' },
    { code: '+973', name: 'Bahrain' },
    { code: '+974', name: 'Qatar' },
    { code: '+975', name: 'Bhutan' },
    { code: '+976', name: 'Mongolia' },
    { code: '+977', name: 'Nepal' },
    { code: '+992', name: 'Tajikistan' },
    { code: '+993', name: 'Turkmenistan' },
    { code: '+994', name: 'Azerbaijan' },
    { code: '+995', name: 'Georgia' },
    { code: '+996', name: 'Kyrgyzstan' },
    { code: '+998', name: 'Uzbekistan' },
];

const ProfileCompletionModal: React.FC<ProfileCompletionModalProps> = ({
    isOpen,
    onClose,
    onComplete
}) => {
    const { currentUser, refreshUserProfile, missingProfileFields } = useAuth();
    const [companyName, setCompanyName] = useState('');
    const [countryCode, setCountryCode] = useState('+91');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const dropdownRef = useRef<HTMLDivElement>(null);

    // Filter countries based on search query
    const filteredCountries = COUNTRY_CODES.filter(country =>
        country.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        country.code.includes(searchQuery)
    );

    // Get selected country display text (use first match if multiple countries share same code)
    const selectedCountry = COUNTRY_CODES.find(c => c.code === countryCode);
    const displayText = selectedCountry ? `${selectedCountry.code} (${selectedCountry.name})` : `${countryCode} (Select country)`;

    // Handle click outside to close dropdown
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsDropdownOpen(false);
                setSearchQuery('');
            }
        };

        if (isDropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isDropdownOpen]);

    // Function to validate phone number
    const validatePhoneNumber = (phone: string, showError: boolean = false): boolean => {
        const cleanedPhone = phone.replace(/\s/g, '');

        // Check 1: Empty
        if (!cleanedPhone) {
            if (showError) setPhoneError('');
            return false;
        }

        // Check 2: Only digits
        if (!/^\d+$/.test(cleanedPhone)) {
            if (showError) setPhoneError('Phone number must contain only numeric digits');
            return false;
        }

        // Check 3: Minimum length (10 digits)
        if (cleanedPhone.length < 5) {
            if (showError) setPhoneError('Enter a valid phone number');
            return false;
        }

        // Valid!
        if (showError) setPhoneError('');
        return true;
    };

    // Handle phone number input - sanitizes and validates
    const handlePhoneNumberChange = (value: string) => {
        // Remove non-numeric characters (except spaces)
        const sanitized = value.replace(/[^\d\s]/g, '');
        setPhoneNumber(sanitized);

        // Validate and show errors
        if (sanitized.trim()) {
            validatePhoneNumber(sanitized, true);
        } else {
            setPhoneError('');
        }
    };

    // Check if user has entered all required data
    const hasValidInput = () => {
        const isCompanyNameValid = !missingProfileFields?.companyName || companyName.trim();
        const isPhoneValid = !missingProfileFields?.phoneNumber ||
            (phoneNumber.trim() && validatePhoneNumber(phoneNumber, false));
        return isCompanyNameValid && isPhoneValid;
    };

    const handleSubmit = async () => {
        if (!currentUser?.uid || !hasValidInput()) return;

        try {
            setLoading(true);
            setError('');

            const updates: { companyName?: string; phoneNumber?: string } = {};

            // Include all required fields
            if (missingProfileFields?.companyName) {
                updates.companyName = companyName.trim();
            }
            if (missingProfileFields?.phoneNumber) {
                // Validate phone number before submitting (show errors if invalid)
                if (!validatePhoneNumber(phoneNumber, true)) {
                    setLoading(false);
                    return;
                }
                // Combine country code with phone number
                const cleanedPhone = phoneNumber.replace(/\s/g, '');
                updates.phoneNumber = `${countryCode}${cleanedPhone}`;
            }

            const response = await updateUserProfile(currentUser.uid, updates);

            if (response.success) {
                // Refresh the user profile data
                await refreshUserProfile();
                // Clear snooze on successful completion
                clearProfileSnooze(currentUser.uid);
                onComplete();
            } else {
                setError('Failed to update profile. Please try again.');
            }
        } catch (err) {
            console.error('Failed to update profile:', err);
            setError('Failed to update profile. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4 relative">
                {/* Header */}
                <div className="mb-6">
                    <h2 className="text-2xl font-bold text-text-heading mb-2">Complete Your Profile</h2>
                    <p className="text-text-description">
                        {missingProfileFields?.companyName && missingProfileFields?.phoneNumber
                            ? 'Please provide your company name and phone number to continue'
                            : missingProfileFields?.companyName
                                ? 'Please provide your company information to continue'
                                : 'Please provide your phone number to continue'
                        }
                    </p>
                </div>

                {/* Error message */}
                {error && (
                    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                        <i className="fas fa-exclamation-circle mr-2"></i>
                        {error}
                    </div>
                )}

                {/* Form */}
                <div className="space-y-4 mb-6">
                    {missingProfileFields?.companyName && (
                        <div>
                            <label className="block text-sm font-medium text-text-heading mb-1">
                                Company Name <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                value={companyName}
                                onChange={(e) => setCompanyName(e.target.value)}
                                placeholder="Enter your company name"
                                className="w-full px-3 py-2 border border-accent-taupe rounded-md focus:outline-none focus:ring-2 focus:ring-secondary-500 focus:border-secondary-500"
                                disabled={loading}
                                required
                            />
                        </div>
                    )}

                    {missingProfileFields?.phoneNumber && (
                        <div>
                            <label className="block text-sm font-medium text-text-heading mb-1">
                                Phone Number <span className="text-red-500">*</span>
                            </label>
                            <div className="flex gap-2">
                                <div className="relative" ref={dropdownRef}>
                                    <button
                                        type="button"
                                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                        disabled={loading}
                                        className="px-3 py-2 border border-accent-taupe rounded-md focus:outline-none focus:ring-2 focus:ring-secondary-500 focus:border-secondary-500 bg-white text-left w-[200px] flex items-center justify-between disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        <span className="text-sm truncate">{displayText}</span>
                                        <svg
                                            className={`w-4 h-4 ml-2 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`}
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                        </svg>
                                    </button>
                                    {isDropdownOpen && (
                                        <div className="absolute z-50 mt-1 w-full bg-white border border-accent-taupe rounded-md shadow-lg max-h-60 overflow-hidden">
                                            <div className="p-2 border-b border-accent-taupe">
                                                <input
                                                    type="text"
                                                    placeholder="Search country..."
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                    className="w-full px-3 py-2 text-sm border border-accent-taupe rounded-md focus:outline-none focus:ring-2 focus:ring-secondary-500 focus:border-secondary-500"
                                                    autoFocus
                                                />
                                            </div>
                                            <div className="overflow-y-auto max-h-48">
                                                {filteredCountries.length > 0 ? (
                                                    filteredCountries.map((country, index) => (
                                                        <button
                                                            key={`${country.code}-${country.name}-${index}`}
                                                            type="button"
                                                            onClick={() => {
                                                                setCountryCode(country.code);
                                                                setIsDropdownOpen(false);
                                                                setSearchQuery('');
                                                            }}
                                                            className={`w-full text-left px-3 py-2 text-sm hover:bg-secondary-100 focus:bg-secondary-100 focus:outline-none ${
                                                                countryCode === country.code ? 'bg-secondary-100 font-medium' : ''
                                                            }`}
                                                        >
                                                            {country.code} ({country.name})
                                                        </button>
                                                    ))
                                                ) : (
                                                    <div className="px-3 py-2 text-sm text-text-description text-center">
                                                        No countries found
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="flex-1">
                                    <input
                                        type="tel"
                                        value={phoneNumber}
                                        onChange={(e) => handlePhoneNumberChange(e.target.value)}
                                        placeholder="Enter phone number"
                                        className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-secondary-500 focus:border-secondary-500 ${phoneError ? 'border-red-500' : 'border-accent-taupe'
                                            }`}
                                        disabled={loading}
                                        required
                                    />
                                </div>
                            </div>
                            {phoneError && (
                                <p className="text-red-500 text-xs mt-1">
                                    <i className="fas fa-exclamation-circle mr-1"></i>
                                    {phoneError}
                                </p>
                            )}
                        </div>
                    )}
                </div>

                {/* Buttons */}
                <div className="flex flex-col space-y-3">
                    <button
                        onClick={handleSubmit}
                        disabled={loading || !hasValidInput()}
                        className="w-full bg-secondary-500 text-white py-2 px-4 rounded-md hover:bg-secondary-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {loading ? (
                            <div className="flex items-center justify-center">
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                Saving...
                            </div>
                        ) : (
                            'Continue'
                        )}
                    </button>
                </div>

                {/* Info text */}
                <p className="text-xs text-text-description text-center mt-4">
                    <span className="text-red-500">*</span> Required fields - Please complete all fields to continue using the platform.
                </p>
            </div>
        </div>
    );
};

export default ProfileCompletionModal;
